import styled from "@emotion/styled";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@porchpass/ui";
import { BaseCell } from "src/components/Table/Cells/shared";
import { EllipseVerticalIcon } from "src/assets/icons";
import { GHOST_BACKGROUND } from "src/constants/colors";

const EditIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 16.1249 16.1259"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <path
      d="M2.95787 10.1904C5.00834 8.96951 7.47878 8.68882 9.72057 9.34375C10.0184 9.43101 10.1893 9.74305 10.1024 10.041C10.0153 10.339 9.70317 10.5106 9.40514 10.4238C7.45551 9.85425 5.30832 10.1002 3.53307 11.1572C3.40723 11.2321 3.26927 11.3107 3.12486 11.3926C2.59045 11.6958 1.96613 12.0498 1.53111 12.4756C1.26138 12.7397 1.14632 12.9576 1.12779 13.126C1.11317 13.2598 1.14724 13.4807 1.48521 13.8027C2.26203 14.5428 3.05147 15 4.00572 15H6.93736C7.24802 15 7.49986 15.2518 7.49986 15.5625C7.49985 15.8732 7.24802 16.125 6.93736 16.125H4.00572C2.64199 16.125 1.58743 15.4542 0.708848 14.6172C0.199595 14.132 -0.0539752 13.5858 0.00962903 13.0039C0.0694868 12.4568 0.397788 12.0098 0.744004 11.6709C1.29752 11.1291 2.10588 10.6737 2.64049 10.3721C2.76249 10.3032 2.87064 10.2424 2.95787 10.1904ZM13.1102 8.47754C13.6046 8.18352 14.2157 8.1739 14.7186 8.45312C14.9283 8.56964 15.1138 8.75923 15.3241 8.97461C15.3399 8.99083 15.3558 9.00792 15.3719 9.02441C15.3877 9.04052 15.4033 9.05647 15.4188 9.07227C15.6306 9.28808 15.8165 9.4769 15.9296 9.68945C16.1981 10.1944 16.1892 10.8048 15.9061 11.3018C15.7869 11.5109 15.5957 11.694 15.3778 11.9033C15.3618 11.9186 15.3462 11.9346 15.3299 11.9502L12.1561 15.0068C12.1324 15.0296 12.1088 15.053 12.0858 15.0752C11.6495 15.4961 11.3188 15.8144 10.8963 15.9795C10.4726 16.145 10.0158 16.1334 9.41588 16.1172C9.38422 16.1163 9.35167 16.1151 9.3192 16.1143L9.22447 16.1113C9.21818 16.1112 9.21158 16.1115 9.20494 16.1113C9.11762 16.1091 9.00193 16.1057 8.90123 16.0889C8.77536 16.0679 8.5886 16.0142 8.43834 15.8438C8.28991 15.6753 8.25878 15.4854 8.25182 15.3613C8.24617 15.2599 8.25454 15.1441 8.26158 15.0547C8.2621 15.0481 8.26305 15.0414 8.26354 15.0352L8.27232 14.918C8.27446 14.8906 8.2771 14.8636 8.27916 14.8369C8.31989 14.3099 8.35003 13.9163 8.5067 13.5557C8.66376 13.1942 8.9298 12.9059 9.28502 12.5215C9.30309 12.5019 9.32215 12.482 9.34068 12.4619L12.4735 9.06738C12.4892 9.05042 12.505 9.03328 12.5204 9.0166C12.7244 8.79501 12.9041 8.6002 13.1102 8.47754ZM14.1717 9.43652C14.0192 9.35199 13.8358 9.35492 13.6854 9.44434C13.64 9.47139 13.5793 9.52815 13.3006 9.83008L10.1669 13.2256C9.73328 13.6953 9.61062 13.839 9.53893 14.0039C9.46736 14.1686 9.44475 14.3588 9.39537 14.9912C10.0984 15.0091 10.3056 15.0025 10.4872 14.9316C10.6737 14.8587 10.8365 14.7158 11.3749 14.1973L14.5487 11.1396C14.8437 10.8555 14.901 10.7934 14.9286 10.7451C15.0207 10.5835 15.0239 10.3824 14.9364 10.2178C14.9102 10.1685 14.8549 10.1044 14.5682 9.81152C14.2804 9.5175 14.2178 9.46209 14.1717 9.43652ZM8.06236 0C10.2369 5.12823e-05 11.9999 1.76291 11.9999 3.9375C11.9999 6.11209 10.2369 7.87495 8.06236 7.875C5.88774 7.875 4.12486 6.11212 4.12486 3.9375C4.12486 1.76288 5.88774 0 8.06236 0ZM8.06236 1.125C6.50906 1.125 5.24986 2.3842 5.24986 3.9375C5.24986 5.4908 6.50906 6.75 8.06236 6.75C9.61562 6.74995 10.8749 5.49077 10.8749 3.9375C10.8749 2.38423 9.61562 1.12505 8.06236 1.125Z"
      fill="currentColor"
    />
  </svg>
);

const BlockIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 16.125 16.125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <path
      d="M8.0625 0C12.5153 0 16.125 3.6097 16.125 8.0625C16.125 12.5153 12.5153 16.125 8.0625 16.125C3.6097 16.125 0 12.5153 0 8.0625C0 3.6097 3.6097 0 8.0625 0ZM2.77637 3.57129C1.74702 4.78163 1.125 6.34914 1.125 8.0625C1.125 11.894 4.23102 15 8.0625 15C9.77582 15 11.3424 14.377 12.5527 13.3477L2.77637 3.57129ZM8.0625 1.125C6.34914 1.125 4.78163 1.74702 3.57129 2.77637L13.3477 12.5527C14.377 11.3424 15 9.77582 15 8.0625C15 4.23102 11.894 1.125 8.0625 1.125Z"
      fill="currentColor"
    />
  </svg>
);

const CellContainer = styled(BaseCell)`
  position: relative;
  justify-content: flex-end;
`;

const IconWrapper = styled.div`
  padding: 6px;
  border-radius: 150px;
  cursor: pointer;

  &:hover {
    background-color: ${GHOST_BACKGROUND};
  }
`;

export const MenuCell = ({
  canManageEmployees,
  setActiveEmployee,
  onDeactivate,
}: {
  canManageEmployees: boolean;
  setActiveEmployee: () => void;
  onDeactivate: () => void;
}) => {
  if (!canManageEmployees) {
    return <CellContainer />;
  }

  return (
    <CellContainer>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconWrapper>
            <EllipseVerticalIcon />
          </IconWrapper>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={setActiveEmployee}>
            <EditIcon />
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={onDeactivate}
            className="hover:bg-[#b93c3c] hover:text-white focus:bg-[#b93c3c] focus:text-white"
          >
            <BlockIcon />
            Deactivate
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </CellContainer>
  );
};
